import LeadActionModel from '@/models/lead/lead-action-model'
import NeedsCalculatorFormModel from '@/models/needscalculator/needs-calculator-form-model'

export default class LeadActionFormModel extends LeadActionModel {
  needsCalculatorFormID!: number

  needsCalculatorForm!: NeedsCalculatorFormModel
}
